var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.url)?_c('object',{attrs:{"id":"regro-preview-url","data":_vm.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }